export default "/images/64e9324844e2c44977e5e8be5d495a00.avif";